export const FreightStatuses = {
    'Open for Bids': {
        title: 'Open for Bids',
        icon: 'ri-price-tag-3-line',
        className: 'badge-soft-success',
    },
    'In Verification': {
        title: 'In Verification',
        icon: 'ri-search-eye-line',
        className: 'badge-soft-info',
    },
    'Action Required': {
        title: 'Action Required',
        icon: 'ri-alert-line',
        className: 'badge-soft-warning',
    },
    'Issues Detected': {
        title: 'Issues Detected',
        icon: 'ri-error-warning-line',
        className: 'badge-soft-danger',
    },
    'Closed': {
        title: 'Closed',
        icon: 'ri-archive-line',
        className: 'badge-soft-secondary',
    },
};

export const FreightTabs = [
    {
        key: 'all',
        title: 'All Freights',
        status: undefined,
    },
    {
        key: 'open_for_bids',
        title: 'Open for Bids',
        status: 'Open for Bids',
    },
    {
        key: 'in_verification',
        title: 'In Verification',
        status: 'In Verification',
    },
    {
        key: 'closed',
        title: 'Closed',
        status: 'Closed',
    },
];

export const CargoTypes = {
    'Electronics': 'ri-computer-line',
    'Automotive Parts': 'ri-car-line',
    'Industrial Machinery': 'ri-tools-line',
    'Chemicals': 'ri-flask-line',
    'Food & Beverage': 'ri-restaurant-line',
    'Consumer Goods': 'ri-shopping-bag-line',
    'Pharmaceuticals': 'ri-hospital-line',
    'Raw Materials': 'ri-plant-line',
};

export const VerificationStates = [
    {
        key: 'verified',
        title: 'verified',
        className: 'verified',
    },
    {
        key: 'review',
        title: 'review',
        className: 'review',
    },
    {
        key: 'rejected',
        title: 'rejected',
        className: 'rejected',
    },
];

export const FreightSummaryWidgets = {
    total: {
        icon: 'ri-truck-line',
        color: 'primary',
    },
    bids: {
        icon: 'ri-group-line',
        color: 'info',
    },
    verified: {
        icon: 'ri-shield-star-line',
        color: 'success',
    },
    action: {
        icon: 'ri-alert-line',
        color: 'warning',
    },
    rejected: {
        icon: 'ri-close-circle-line',
        color: 'danger',
    },
};